// extracted by mini-css-extract-plugin
export default {"card":"ForgotPassword_card__GWqrZ","outerCard":"ForgotPassword_outerCard__KWNty","zenImage":"ForgotPassword_zenImage__IN6OY"};